import React, { useState, useEffect, useContext }  from 'react';
import styles from 'components/layout_and_quote_builder/_style.module.scss';
import LayoutNavSection from 'components/layout_and_quote_builder/LayoutNavSection.jsx';
import LayoutNavSectionCombinationList from 'components/layout_and_quote_builder/LayoutNavSectionCombinationList.jsx';
import SelectedList from 'components/layout_and_quote_builder/quote_builder/SelectedList.jsx';
import LayoutContext from 'components/contexts/LayoutContext.jsx';
import ChooseLayoutDimensions from 'components/layout_and_quote_builder/options/ChooseLayoutDimensions.jsx';
import GeneralNavSection from 'components/layout_and_quote_builder/quote_builder/GeneralNavSection.jsx';

const LayoutAndQuoteBuilderNavSection = ( props ) => {
  const myLayoutContext = useContext(LayoutContext);

  const defaultMaterialValues = () => {
    return {
      layout_dimension_id:  myLayoutContext.layoutOptions.layout_dimension_id,
      layout_dimension_unit: myLayoutContext.layoutOptions.layout_dimension_unit,
      layout_dimension_top_margin_diecutting: myLayoutContext.layoutOptions.layout_dimension_top_margin,
      layout_dimension_side_margin_diecutting: myLayoutContext.layoutOptions.layout_dimension_side_margin,
      layout_dimension_bottom_margin_diecutting: myLayoutContext.layoutOptions.layout_dimension_bottom_margin,

      layout_dimension_top_margin_printing: myLayoutContext.layoutOptions.layout_dimension_top_margin,
      layout_dimension_side_margin_printing: myLayoutContext.layoutOptions.layout_dimension_side_margin,
      layout_dimension_bottom_margin_printing: myLayoutContext.layoutOptions.layout_dimension_bottom_margin,
    }
  }
  const [selectedList, setSelectedList] = useState( [] )
  const [materialLayoutDimensions, setMaterialLayoutDimensions] = useState( defaultMaterialValues() )

  const navSectionLabel = () => {
    if(props.navSection.label) {
      return <span className={styles.navSectionLabel}> {props.navSection.label} </span>
    }
  }

  const chooseLayoutDimensionsComponent = () => {
    return <ChooseLayoutDimensions
      title="Malzeme Tabaka Boyutlari"
      hideMargins={false}
      disableMargins={selectedList.length != 0}
      hideCustom={true}
      defaultValues={materialLayoutDimensions}
      publicSetter={setMaterialLayoutDimensions}
      index={props.index}
    />
  }

  // const applyCurrentValue = () => {
  //   return
  //   let index = props.index;
  //   if(selectedList.length > 0 ) { return }
  //   if(window.user_quote_nav_sections == undefined) { return }
  //   if(window.user_quote_nav_sections.length == 0)  { return }
  //   if(window.user_quote_nav_sections[index] == undefined)  { return }
  //   if(window.user_quote_nav_sections[index].selected_lists == undefined)  { return }

  //   for(let i = 0; window.user_quote_nav_sections[index].selected_lists.length; i++) {
  //     if(window.user_quote_nav_sections[index].selected_lists[i]!= undefined) {
  //        // setSelectedList( () => window.user_quote_nav_sections[index].selected_lists[i] )
  //        // alert("hehe");
  //     }
  //   }
  // }

  // useEffect( applyCurrentValue, [] )

  useEffect( () => {
    // console.log( { materialLayoutDimensions } )
  }, [materialLayoutDimensions])

  useEffect( () => {
    // console.log( { props } )
  }, [props])


  if(props.navSection.part_type == "general") {
    return <GeneralNavSection />
  }

  return (
    <>
    <div className={styles.LayoutAndQuoteBuilderNavSection}>

      <div className={styles.nav_section}>

        {props.navSection.label != undefined && props.navSection.label != '' && (

          <div className="col-lg-12">
            <div className="promo-block">
              <div className="promo-text"> {props.navSection.label} </div>
            </div>
          </div>
        )}

        <div className={styles.nav_section_layout_selector}> <span> {chooseLayoutDimensionsComponent()} </span> </div>

          { selectedList.length == 0 && <LayoutNavSectionCombinationList
            navSection={props.navSection}
            index={props.index}
            count={props.count}
            setSelectedList={setSelectedList}
            materialLayoutDimensions={materialLayoutDimensions}
          /> }

        <SelectedList selectedList={selectedList} setSelectedList={setSelectedList} config={props.config} index={props.index} />

      </div>
    </div>
    <br />
    <br />
    </>
  )
}

export default LayoutAndQuoteBuilderNavSection;
